import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <section className="relative pt-32 pb-12 bg-gradient-hero text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-60 h-60 bg-secondary rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto relative z-10">
          <motion.div 
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-extrabold mb-6 font-display">Informativa sulla Privacy</h1>
            <p className="text-xl text-white/80">
              Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003 s.m.i.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-card border border-light-border/50"
          >
            <div className="prose prose-lg max-w-none prose-headings:font-display prose-headings:text-light-text prose-p:text-light-muted prose-li:text-light-muted prose-a:text-primary">
              <p className="text-sm text-light-muted italic">
                Ultimo aggiornamento: Gennaio 2026
              </p>

              <h2>Informativa sul trattamento dei dati personali</h2>
              <p>
                La presente informativa sulla privacy è resa ai sensi dell'art. 13 del Regolamento UE 2016/679 
                (General Data Protection Regulation - "GDPR") e descrive le modalità con cui Rinova Srl raccoglie, 
                utilizza e protegge le informazioni personali degli utenti che visitano il sito web rinovagroup.it.
              </p>

              <h3>1. Titolare del Trattamento dei Dati</h3>
              <p>Il Titolare del trattamento dei dati personali è:</p>
              <ul>
                <li><strong>Ragione sociale:</strong> Rinova Srl</li>
                <li><strong>Sede legale:</strong> Via Fratelli Bandiera 1, 88060 Montepaone (CZ), Frazione Montepaone Lido, Italia</li>
                <li><strong>P.IVA:</strong> IT03994100794</li>
                <li><strong>Email per la privacy:</strong> privacy@rinovagroup.it</li>
                <li><strong>Email generale:</strong> info@rinovagroup.it</li>
              </ul>

              <h3>2. Natura del Servizio Offerto</h3>
              <p>
                Rinova Srl offre un <strong>servizio gratuito di consulenza e comparazione</strong> delle offerte per energia 
                elettrica, gas naturale e connettività internet. Il servizio è rivolto a consumatori privati e aziende.
              </p>
              <p>
                <strong>Rinova Srl non è un fornitore diretto</strong> di energia, gas o servizi internet, ma opera come 
                intermediario indipendente che facilita il confronto tra le offerte disponibili sul mercato. La consulenza 
                è gratuita e <strong>non implica alcun obbligo di sottoscrizione</strong> da parte dell'utente. L'eventuale 
                stipula di un contratto con un fornitore è una decisione libera e autonoma del cliente.
              </p>

              <h3>3. Categorie di Dati Personali Raccolti</h3>
              <p>Il Titolare può raccogliere le seguenti categorie di dati personali:</p>
              
              <h4>3.1 Dati forniti volontariamente dall'utente</h4>
              <ul>
                <li><strong>Dati identificativi:</strong> nome, cognome</li>
                <li><strong>Dati di contatto:</strong> indirizzo email, numero di telefono</li>
                <li><strong>Dati relativi al servizio richiesto:</strong> tipologia di fornitura di interesse, consumi stimati, 
                eventuali messaggi o richieste specifiche</li>
              </ul>

              <h4>3.2 Dati raccolti automaticamente</h4>
              <ul>
                <li><strong>Dati tecnici:</strong> indirizzo IP, tipo e versione del browser, sistema operativo, 
                provider di servizi internet (ISP)</li>
                <li><strong>Dati di navigazione:</strong> pagine visitate, durata della visita, pagine di ingresso e uscita, 
                data e ora dell'accesso</li>
                <li><strong>Cookie e tecnologie similari:</strong> come dettagliato nella nostra{' '}
                  <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link>
                </li>
              </ul>

              <h3>4. Finalità e Base Giuridica del Trattamento</h3>
              <p>I dati personali raccolti sono trattati per le seguenti finalità:</p>
              <table className="min-w-full border text-sm">
                <thead>
                  <tr className="bg-light-background">
                    <th className="border p-3 text-left">Finalità</th>
                    <th className="border p-3 text-left">Base giuridica (art. 6 GDPR)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-3">Erogazione del servizio di consulenza gratuita richiesto dall'utente</td>
                    <td className="border p-3">Esecuzione di misure precontrattuali su richiesta dell'interessato (art. 6.1.b)</td>
                  </tr>
                  <tr>
                    <td className="border p-3">Risposta a richieste di informazioni e contatto</td>
                    <td className="border p-3">Esecuzione di misure precontrattuali (art. 6.1.b) / Legittimo interesse (art. 6.1.f)</td>
                  </tr>
                  <tr>
                    <td className="border p-3">Invio di comunicazioni informative e commerciali su offerte e promozioni</td>
                    <td className="border p-3">Consenso esplicito dell'interessato (art. 6.1.a)</td>
                  </tr>
                  <tr>
                    <td className="border p-3">Analisi statistica e miglioramento del sito web e dei servizi</td>
                    <td className="border p-3">Legittimo interesse del Titolare (art. 6.1.f)</td>
                  </tr>
                  <tr>
                    <td className="border p-3">Adempimento di obblighi di legge (fiscali, contabili, normativi)</td>
                    <td className="border p-3">Obbligo legale (art. 6.1.c)</td>
                  </tr>
                </tbody>
              </table>

              <h3>5. Modalità di Trattamento</h3>
              <p>
                Il trattamento dei dati personali è effettuato mediante strumenti informatici e/o telematici, 
                con modalità organizzative e logiche strettamente correlate alle finalità indicate, e comunque in modo 
                da garantire la sicurezza, l'integrità e la riservatezza dei dati stessi, in conformità alle disposizioni 
                normative vigenti.
              </p>

              <h3>6. Periodo di Conservazione dei Dati</h3>
              <p>I dati personali sono conservati per il tempo strettamente necessario a conseguire le finalità per cui sono stati raccolti:</p>
              <ul>
                <li><strong>Dati di contatto e richieste:</strong> 24 mesi dall'ultimo contatto o interazione</li>
                <li><strong>Dati di navigazione:</strong> 14 mesi dalla raccolta</li>
                <li><strong>Dati per finalità di marketing:</strong> fino alla revoca del consenso, e comunque non oltre 24 mesi dall'ultimo contatto</li>
                <li><strong>Dati per obblighi di legge:</strong> per il periodo previsto dalla normativa applicabile</li>
              </ul>

              <h3>7. Comunicazione e Condivisione dei Dati</h3>
              <p>I dati personali possono essere comunicati a:</p>
              <ul>
                <li><strong>Fornitori di servizi energetici e di connettività:</strong> limitatamente ai dati necessari 
                per l'eventuale attivazione di un'offerta, e <strong>solo previo consenso esplicito dell'utente</strong></li>
                <li><strong>Fornitori tecnici:</strong> che ci assistono nella gestione del sito web, dei sistemi informatici 
                e delle comunicazioni (es. hosting provider, servizi email)</li>
                <li><strong>Consulenti professionali:</strong> commercialisti, avvocati, in adempimento di obblighi di legge</li>
                <li><strong>Autorità pubbliche:</strong> quando richiesto dalla legge o da provvedimenti dell'autorità competente</li>
              </ul>
              <p>
                <strong>Non vendiamo, cediamo o comunichiamo i dati personali a terze parti per finalità di marketing 
                diretto senza il consenso esplicito e preventivo dell'interessato.</strong>
              </p>

              <h3>8. Trasferimento di Dati all'Estero</h3>
              <p>
                I dati personali sono trattati prevalentemente all'interno del territorio dell'Unione Europea. 
                Qualora si rendesse necessario un trasferimento di dati verso paesi terzi, esso avverrà nel rispetto 
                delle garanzie previste dal GDPR (decisioni di adeguatezza, clausole contrattuali standard, 
                o altre garanzie appropriate ai sensi degli artt. 44-49 GDPR).
              </p>

              <h3>9. Diritti dell'Interessato</h3>
              <p>
                Ai sensi degli artt. 15-22 del GDPR, l'interessato ha il diritto di:
              </p>
              <ul>
                <li><strong>Accesso</strong> (art. 15): ottenere conferma dell'esistenza dei propri dati e accedere al loro contenuto</li>
                <li><strong>Rettifica</strong> (art. 16): aggiornare, modificare o integrare i dati</li>
                <li><strong>Cancellazione</strong> (art. 17): ottenere la cancellazione dei dati ("diritto all'oblio")</li>
                <li><strong>Limitazione del trattamento</strong> (art. 18): ottenere la limitazione del trattamento</li>
                <li><strong>Portabilità dei dati</strong> (art. 20): ricevere i dati in formato strutturato e di uso comune</li>
                <li><strong>Opposizione</strong> (art. 21): opporsi al trattamento dei dati, compreso il marketing diretto</li>
                <li><strong>Revoca del consenso</strong> (art. 7): revocare il consenso in qualsiasi momento, senza pregiudicare 
                la liceità del trattamento effettuato prima della revoca</li>
              </ul>
              <p>
                Per esercitare i propri diritti, l'interessato può contattarci all'indirizzo: <strong>privacy@rinovagroup.it</strong>
              </p>
              <p>
                L'interessato ha inoltre il diritto di proporre reclamo all'Autorità Garante per la Protezione 
                dei Dati Personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.garanteprivacy.it</a>).
              </p>

              <h3>10. Cookie e Tecnologie di Tracciamento</h3>
              <p>
                Il sito utilizza cookie e tecnologie similari come dettagliato nella{' '}
                <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link>. 
                L'utente può gestire le proprie preferenze sui cookie attraverso il banner presente sul sito 
                o tramite le impostazioni del proprio browser.
              </p>

              <h3>11. Sicurezza dei Dati</h3>
              <p>
                Il Titolare adotta misure di sicurezza tecniche e organizzative appropriate per proteggere i dati 
                personali contro accessi non autorizzati, perdita, distruzione, uso improprio o alterazione, 
                in conformità con l'art. 32 del GDPR. Tali misure includono, a titolo esemplificativo: crittografia 
                dei dati in transito (SSL/TLS), controllo degli accessi, backup periodici e formazione del personale.
              </p>

              <h3>12. Modifiche all'Informativa</h3>
              <p>
                Il Titolare si riserva il diritto di modificare la presente informativa in qualsiasi momento. 
                Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento. 
                Si invitano gli utenti a consultare periodicamente questa pagina.
              </p>

              <h3>13. Contatti</h3>
              <p>Per qualsiasi domanda o richiesta relativa alla presente informativa:</p>
              <ul>
                <li><strong>Email privacy:</strong> privacy@rinovagroup.it</li>
                <li><strong>Email generale:</strong> info@rinovagroup.it</li>
                <li><strong>Indirizzo postale:</strong> Rinova Srl, Via Fratelli Bandiera 1, 88060 Montepaone (CZ), Italia</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
